import { render } from "./OurPrograms.vue?vue&type=template&id=b3405f6c&scoped=true"
import script from "./OurPrograms.vue?vue&type=script&lang=js"
export * from "./OurPrograms.vue?vue&type=script&lang=js"

import "./OurPrograms.vue?vue&type=style&index=0&id=b3405f6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3405f6c"]])

export default __exports__